import { AssigmentSpecialPermission } from "interfaces";
import { create } from "zustand";

interface AssigmentSpecialPermissionProps {
  item: AssigmentSpecialPermission | null;
  setItem: (item: AssigmentSpecialPermission | null) => void;
  isEdit: boolean;
  setIsEdit: (state: boolean) => void;
  isOpenModal: boolean;
  setIsOpenModal: (state: boolean)=> void;
  handleOpenModal: () => void;
  handleCloseModal: () => void;
  clearAll: () => void;
}

export const useAssigmentSpecialPermissionStore = create<AssigmentSpecialPermissionProps>((set, get) => ({
  item: null,
  setItem: (item) => {
    set({ item: item });
  },
  isEdit: false,
  setIsEdit: (state) => {
    set({ isEdit: state });
  },
  isOpenModal: false,
  setIsOpenModal: (state) => {
    set({ isOpenModal: state });
  },
  handleOpenModal: () => {
    set({ isOpenModal: true });
  },
  handleCloseModal: () => {
    set({ isOpenModal: false });
  },
  clearAll: () => {
    set({
      item: null,
      isEdit: false,
      isOpenModal: false,
    });
  },
}));